import React from 'react';
import ReactDOM from 'react-dom';
import ToastContainer from './ToastContainer';

const toastContainer = document.getElementById('toast-container');

if (toastContainer) {
    ReactDOM.render(React.createElement(ToastContainer), toastContainer);
}
